import React, { useState, useEffect } from 'react';
import './App.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

//import Login from './components/Login/Login';
//import Alternativa from './components/BaseDeConocimientos/Alternativa';
//import Usuarios from './components/Usuarios/Usuarios';

import Menu from './components/Menu';
import auth0Client from './components/Auth/Auth';
import Login from './components/Login/LoginAuth';
import Analisis from './components/Analisis/Analisis';
import Base from './components/BaseDeConocimientos/BaseDeConocimientos';
import Alternativas from './components/BaseDeConocimientos/Alternativas';
import Resultados from './components/BaseDeConocimientos/Resultados';
import Feriados from './components/Feriados/Feriados';
import ListaCasos from './components/ListaCasos/Lista';
import ResultadoCaso from './components/ListaCasos/Resultado';
import DatosCaso from './components/ListaCasos/DatosCaso';
import Inicio from './components/Inicio';
import ConfigImp from './components/configuracion/importacionSige';
import Plantillas from './components/plantillas/plantillas';
import Magistrados from './components/magistrados/magistrados';
import ActualizaCasosAntiguos from './components/configuracion/actualizaCasosAntiguos';

function App() {

  const isAuthenticated = () => {
    console.log('App - isAuthenticated - INI');    
    return auth0Client.isAuthenticated();
  }

  let hasLogged = localStorage.getItem('AccessToken') != null || localStorage.getItem('expires_at') != null || localStorage.getItem('operaciones') != null || localStorage.getItem('nickname') != null ; 

  if( hasLogged && isAuthenticated ){

    return (
      <div className="wrapper">
      
        <BrowserRouter>
        
          <Menu />
          
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/inicio" element={<Inicio />} />
            <Route path="/analisis/:id" element={<Analisis />} />
            <Route path="/baseDeConocimientos" element={<Base />} /> 
            <Route path="/feriados" element={<Feriados />} />
            <Route path="/listaAnalisis" element={<ListaCasos />} />
            <Route path="/resultadoCaso/:id" element={<ResultadoCaso />}  />
            <Route path="/datosCaso/:id" element={<DatosCaso />}  />
            <Route path="/pregunta/:id/alternativas" element={<Alternativas />}  />
            <Route path="/pregunta/:id/resultados" element={<Resultados />}  />
             
            <Route path="/magistrados" element={<Magistrados />}  />
            <Route path="/plantillas" element={<Plantillas />}  />
            <Route path="/configImp" element={<ConfigImp />}  />
            <Route path="/update" element={<ActualizaCasosAntiguos />}  />

          </Routes>
        </BrowserRouter>
  
      </div>
    );

  }else{

    return <Login />

  } 
}

export default App;
